import { ComponentType, createContext, Dispatch, SetStateAction } from 'react';

import { GroupContextType } from '../../utils/groupContextType';

import { CommandListNestedRouterPath } from './commandRoutes';

export type GroupContextActionType = GroupContextType.CUSTOMER_GROUP | GroupContextType.SUPPLIER_GROUP;

export interface ShortcutMenuContextAction {
    id: string;
    label: string;
    Icon?: ComponentType<{ width?: number; height?: number }>;
    destructive?: boolean;
}

export interface ShortcutMenuContextActionRegistration extends ShortcutMenuContextAction {
    onSelect: () => void;
}

interface ShortcutMenuContextType {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    search: string;
    setSearch: Dispatch<SetStateAction<string>>;
    selectedValue: string | undefined;
    setSelectedValue: Dispatch<SetStateAction<string | undefined>>;
    pages: CommandListNestedRouterPath[];
    setPages: Dispatch<SetStateAction<CommandListNestedRouterPath[]>>;
    groupContextActionType: GroupContextActionType | null;
    setGroupContextActionType: Dispatch<SetStateAction<GroupContextActionType | null>>;
    contextActions: ShortcutMenuContextAction[];
    setContextActions: Dispatch<SetStateAction<ShortcutMenuContextAction[]>>;
    getContextActionHandler: (id: string) => (() => void) | undefined;
    setContextActionHandlers: (handlers: Record<string, () => void>) => void;
    clearContextActionHandlers: () => void;
    openGroupContextSelection: () => void;
}

export const ShortcutMenuContext = createContext<ShortcutMenuContextType | null>(null);
